import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as accountUsersActions from "../actions/account_users_actions";
import * as accountUsersTypes from "../types/account_users_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfUsers(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_USERS_PER_ACCOUNT, action.payload);
    if (res.status === 200) {
      yield put(accountUsersActions.getListOfUsersSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountUsersActions.getListOfUsersError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountUsersActions.getListOfUsersError(e));
  }
}

export default function* usersSaga() {
  yield takeLatest(accountUsersTypes.getListOfUsers.GET_LIST_OF_USERS_REQUEST, getListOfUsers);
}
